export const parseCctpError = async (response: Response, fallback: string): Promise<Error> => {
  const text = await response.text()
  return new Error(text || fallback)
}
